import React from 'react';
import UserIcon from "../../icons/user/user";
import Reaction from "../../../model2/reaction/reaction";
import User from "../../../model2/user/user";
import {SortDirection} from "../../../data-structures/sort";

type Props = {
    reactions: Reaction[]
}

export default function ReactionUsersList(props: Props) {


    let users : User[] = _.map(props.reactions, (reaction:Reaction, key) => {
        const user = gd.session.users.get(reaction.userId)!
        return user
    })

    users = _.sortBy(users, 'name', SortDirection.ASC)

    return (
        <div className="ui5-popover-menu min-w-100">
            {_.map(users, (user, key) => {
                    return (
                        <div key={key} className="option">
                            <UserIcon userId={user.id} size="22" hint={false}/>
                            <div className="m-l-10">{user?.name}</div>
                        </div>
                    )
                }
            )}
        </div>
    );
}